module.exports = __webpack_public_path__ + "img/Entity.1efa603d.svg";